import type { AgentRole, NaradaTheme } from "@/lib/api";

export const FALLBACK_ROSTER: AgentRole[] = [
  {
    id: "bart",
    label: "Bart",
    axis: "Jedna myśl mentora sprzedaży",
    source: "nagrania i notatki Barta, żywe liczby",
    forbidden: "nie pisze jako Kasia, nie zmienia systemu",
  },
  {
    id: "corka",
    label: "Córka",
    axis: "Czy to o mnie w dwie sekundy",
    source: "komentarze i historie z Messengera",
    forbidden: "nie pisze wykładu",
  },
  {
    id: "glos",
    label: "Głos",
    axis: "Czy to brzmi jak Kasia",
    source: "głos Kasi, jej weto",
    forbidden: "nie zastępuje Kasi w rolkach",
  },
  {
    id: "architekt",
    label: "Architekt",
    axis: "Czy tydzień treści ma kształt",
    source: "system treści i typy karuzel",
    forbidden: "nie publikuje",
  },
  {
    id: "narzedziarka",
    label: "Narzędziarka",
    axis: "Jakie narzędzie z książki tu pasuje",
    source: "oferta, która naprawdę jest na checkoutcie",
    forbidden: "nie obiecuje wariantu, którego nie ma",
  },
  {
    id: "analityczka",
    label: "Analityczka",
    axis: "Jedna decyzja z liczb",
    source: "sprzedaż, scorecard, karuzele",
    forbidden: "nie wpisuje zera zamiast braku danych",
  },
  {
    id: "straznik",
    label: "Strażnik",
    axis: "Czy Kasia to udźwignie",
    source: "tempo nagrań, oś echa, weto Kasi",
    forbidden: "nie moralizuje, nie kasuje planu za karę",
  },
  {
    id: "szef",
    label: "Szef",
    axis: "Trzy skały, jeden tydzień",
    source: "rytm, priorytety, to co już leży na stole",
    forbidden: "nie dodaje projektu, nie zrzuca skał na tablicę",
  },
  {
    id: "redaktor",
    label: "Redaktor",
    axis: "Zamyka zdanie zespołu",
    source: "głosy i materiały",
    forbidden: "nie pisze copy jako Kasia",
  },
];

export const FALLBACK_THEMES: NaradaTheme[] = [
  {
    id: "tresc",
    label: "Treści i profil",
    plain: "Czy tydzień zostawia skrzydła, czy tylko ból?",
    schema_ids: ["mofu-tydzien", "balans-profilu", "system-tresci", "glos-bazy"],
    default_schema_id: "mofu-tydzien",
  },
  {
    id: "oferta",
    label: "Oferta i książki",
    plain: "Czy cena, skład i obietnica mówią to samo?",
    schema_ids: ["oferta-prawda", "diament", "portfel-linia"],
    default_schema_id: "oferta-prawda",
  },
  {
    id: "liczby",
    label: "Liczby i reklamy",
    plain: "Jedna decyzja z liczb. Kiedy wolno dołożyć reklamę.",
    schema_ids: ["scorecard", "skala-ads"],
    default_schema_id: "scorecard",
  },
  {
    id: "pozakup",
    label: "Po zakupie",
    plain: "Co się dzieje po zakupie i czy paczka dochodzi.",
    schema_ids: ["droga-klientki", "wysylka"],
    default_schema_id: "droga-klientki",
  },
  {
    id: "granice",
    label: "Granice i dalej",
    plain: "Czego nie robimy. Co zostaje na później.",
    schema_ids: ["marka-granice", "rytm-wip", "discovery", "ekspansja"],
    default_schema_id: "marka-granice",
  },
];

export const TILT_LABEL: Record<string, string> = {
  filtr: "Tydzień nachyla profil w stronę samego bólu.",
  nadzieja: "Zostawia nadzieję na siatce.",
  mieszane: "Jest i echo, i skrzydła.",
  nie_dotyczy: "To pytanie nie dotyczy siatki.",
};

const HANDOFF_LABEL: Record<string, string> = {
  "/karuzele": "Studio karuzel",
  "/sprzedaz": "Sprzedaż",
  "/podsumowanie": "Podsumowanie",
  "/komentarze": "Komentarze",
  "/barometr": "Barometr marki",
  "/historie-messenger": "Historie Messenger",
  "/wysylka": "Wysyłka",
  "/status": "Status",
  "/dzis": "Dziś",
  "/bart": "Bart",
  "/plan-tygodnia": "Plan tygodnia",
  "/tydzien-arka": "Tydzień Arka",
  "/publikacje": "Publikacje",
  "/wiedza": "Wiedza",
  "/kanban": "Kanban",
};

export function handoffLabel(path: string): string {
  const key = path.startsWith("/") ? path : `/${path}`;
  return HANDOFF_LABEL[key] || key.replace(/^\//, "") || "Otwórz";
}

export function statusLabel(status?: string): string {
  if (status === "completed") return "gotowe";
  if (status === "error") return "nie wyszło";
  if (status === "running") return "czyta";
  return status || "";
}
